var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"width":"20%"}},[(_vm.taxPayer.id)?_c('span',[_c('span',{class:{'set-click': _vm.clickable && _vm.isAdminLogin && _vm.entityId},on:{"click":_vm.gotoProfile}},[_vm._v(_vm._s(_vm.taxPayer.reg_no))]),(_vm.requireName)?_c('span',[_vm._v("("+_vm._s(_vm.getFullName())+")")]):_vm._e()]):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }